var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.getShowSubjectAreaBanner(_vm.$totemLang))?_c('div',{staticClass:"search-list-headline"},[_c('h1',{staticClass:"search-list-headline__title",domProps:{"innerHTML":_vm._s(_vm.headline.title)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }